export const ROUTES = {
  home: '/',
  changePassword: '/change-password',
  login: '/login',
  register: '/register',
  detail: ':id',
  me: '/me',
  new: 'new',
  users: '/users',
  userDetail: ':userName',
  medicalCenters: '/medical-centers',
  doctors: '/doctors',
  patients: '/patients',
  reports: '/reports',
  reportDetail: ':reportId',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  pdfConfiguration: '/pdf-confguration',
} as const;
